import { render, staticRenderFns } from "./ic_stats_learned_trending_up.svg?vue&type=template&id=7c87ff2e&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports